import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useEffect } from 'react'
import { useIsMounted } from '@dtx-company/true-common/src/hooks/useIsMounted'

export function useProfitWellUserSync(): void {
  const { isAuthChecked, jwt } = useAuthState()
  const isMounted = useIsMounted()
  useEffect(() => {
    if (isAuthChecked && isMounted() && window?.profitwell && jwt?.email) {
      window.profitwell('user_email', jwt.email)
    }
  }, [isAuthChecked, isMounted, jwt?.email])
}
